import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
} from '@appblocks/codegeneration/types';
import Nodes from '@appblocks/codegeneration/Nodes/index';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';

export default class NodeLink extends BaseFeature {
    constructor() {
        super();
        this.name = 'Block Link';
        this.id = 'node_link';

        const settings: Setting[] = [
            {
                id: 'SOURCE',
                name: 'Source',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'SOURCE_FEATURE',
                name: 'Source',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'SOURCE_PORT',
                name: 'Source Port',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'TARGET',
                name: 'Target',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'TARGET_FEATURE',
                name: 'Target',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'TARGET_PORT',
                name: 'Target Port',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'ARGUMENTS',
                name: 'Passed Arguments',
                settingType: SettingType.ARRAY,
                required: true,
                refId: 'node_argument',
                default: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getState(settingId: string): SettingState {
        return SettingState.HIDDEN;
    }

    validate(): ValidationMessage[] {
        const messages: ValidationMessage[] = [];
        const project: ProjectConfiguration = this.project;
        if (this.getSettingValue('SOURCE_PORT') === '') {
            const port = project.getFeature(this.getSettingValue('SOURCE'));
            if (port) {
                messages.push({
                    messageType: ValidationMessageType.UPDATE,
                    message: '',
                    featureId: this.getID(),
                    settingId: 'SOURCE_PORT',
                    data: port.getSettingValue('PORTID'),
                });
                const parent = project.getParent(port);
                messages.push({
                    messageType: ValidationMessageType.UPDATE,
                    message: '',
                    featureId: this.getID(),
                    settingId: 'SOURCE_FEATURE',
                    data: parent.getID(),
                });
            }
        }
        if (this.getSettingValue('TARGET_PORT') === '') {
            const port = project.getFeature(this.getSettingValue('TARGET'));
            if (port) {
                messages.push({
                    messageType: ValidationMessageType.UPDATE,
                    message: '',
                    featureId: this.getID(),
                    settingId: 'TARGET_PORT',
                    data: port.getSettingValue('PORTID'),
                });
                const parent = project.getParent(port);
                messages.push({
                    messageType: ValidationMessageType.UPDATE,
                    message: '',
                    featureId: this.getID(),
                    settingId: 'TARGET_FEATURE',
                    data: parent.getID(),
                });
            }
        }
        // const ARGUMENTS = this.getSettingValue('ARGUMENTS');
        // const targetFeature: BaseNode
        // = project.getFeature(this.getSettingValue('TARGET_FEATURE')) as BaseNode;
        // const targetPort = targetFeature.getPort(this.getSettingValue('TARGET_PORT'));
        // for (let i = 0; i < targetPort.params.length; i++) {
        //     const param = targetPort.params[i];
        //     let found = false;
        //     for (let j = 0; j < ARGUMENTS.length; j++) {
        //         if (ARGUMENTS[j].getSettingValue('TARGETPARAM') === param.name) {
        //             found = true;
        //             break;
        //         }
        //     }
        //     if (!found) {
        //         const arg = FeatureUtils.getCodeItem('node_argument', this.project);
        //         arg.initSettings(project);
        //         arg.setSettingValue('TARGETPARAM', param.name);
        //         arg.setSettingValue('ARGTYPE', 'expression');
        //         arg.setSettingValue('ARGVALUE', param.default
        // === undefined ? '' : param.default);
        //         ARGUMENTS.push(arg);
        //     }
        // }
        // for (let i = 0; i < ARGUMENTS.length; i++) {
        //     let found = false;
        //     for (let j = 0; j < targetPort.params.length; j++) {
        //         if (ARGUMENTS[i].getSettingValue('TARGETPARAM') === targetPort.params[j].name) {
        //             found = true;
        //         }
        //     }
        //     if (!found) {
        //         ARGUMENTS.splice(i, 1);
        //         i--;
        //     }
        // }
        // this.setSettingValue('ARGUMENTS', ARGUMENTS);
        return messages;
    }

    getSourceId(): string {
        return `${this.getSettingValue('SOURCE_FEATURE')}_${this.getSettingValue('SOURCE_PORT')}`;
    }

    getTargetId(): string {
        return `${this.getSettingValue('TARGET_FEATURE')}_${this.getSettingValue('TARGET_PORT')}`;
    }
}
